"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useErrorManager = void 0;
var react_1 = require("react");
var _1 = require(".");
var useErrorManager = function () {
    var errorConfig = (0, _1.useErrorContext)();
    var _a = (0, react_1.useState)(new Error()), error = _a[0], setError = _a[1];
    var isAuthError = function (err) { return err.cause !== undefined; };
    var getErrorDisplayConfig = function (err) {
        if (isAuthError(err)) {
            return __assign(__assign({}, errorConfig), { dialogConfig: { title: err.cause.title }, error: err.cause.errorMessage, onClose: function () {
                    setError(new Error());
                } });
        }
        return __assign(__assign({}, errorConfig), { error: err.message, onClose: function () {
                setError(new Error());
            } });
    };
    var triggerError = function (err) {
        if (isAuthError(err)) {
            setError({
                cause: {
                    title: err.cause.title,
                    errorMessage: err.cause.errorMessage,
                },
            });
        }
        else {
            setError(err);
        }
    };
    return { triggerError: triggerError, errorManagerConfig: getErrorDisplayConfig(error) };
};
exports.useErrorManager = useErrorManager;
